import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { LoadingBehaviorSubject } from '@stylehaven/components';

@Component({
    selector: 'med-navigation-loading',
    templateUrl: './navigation-loading.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationLoadingComponent {
    private loadingState$: LoadingBehaviorSubject = new LoadingBehaviorSubject();

    public loading$: Observable<boolean>;

    constructor(private readonly router: Router) {
        this.setupRouterSubscriptions();
        this.loading$ = this.loadingState$.pipe(debounceTime(200));
    }

    private setupRouterSubscriptions(): void {
        this.router.events.subscribe(event => {
            switch (true) {
                case event instanceof NavigationStart: {
                    this.loadingState$.startLoading();
                    break;
                }

                case event instanceof NavigationEnd:
                case event instanceof NavigationCancel:
                case event instanceof NavigationError: {
                    this.loadingState$.stopLoading();
                    break;
                }
                default: {
                    break;
                }
            }
        });
    }
}
